import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { from, Subscription } from "rxjs";
import { Filter, Search, VizDocSearchRequest } from "src/app/_shared/models/publication-results.model";
import { Method, Methods, VizPreProject } from "../../models/project.model";
import { VizPublicationService } from "../analysis-refine-content/analysis-refinement.service";
import { map, take, toArray } from "rxjs/operators";
import { DbFilter, PubFilter } from "../../models/viz.models";
import { LOCAL_STORAGE_KEYS } from "src/app/shared/constants/storage-keys";

@Component({
    selector: "tdms-analysis-create-content",
    templateUrl: "./analysis-create-content.component.html",
    styleUrls: ["./analysis-create-content.component.scss"],
    standalone: false
})
export class AnalysisCreateContentComponent implements OnInit, AfterViewInit {
  isLoading = true;
  isQuery = false;
  isShowQuery = false;
  isCreating = false;
  isError = false;
  errorMessage = "";

  NONAME = "Please enter a name.";
  INVALIDNAME = "The field you entered is invalid. Please try again";

  createProject: any;
  docCount: string;
  publications: string;
  query: string;
  pubResponse: any;
  searchRequest: VizDocSearchRequest;
  creationSubscription: Subscription;
  pubResponseSubcription: Subscription;
  workbenchId: string;
  selectedVizText: string;
  @ViewChild("datasetNameInput", { static: false }) inputRef!: ElementRef;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private pubService: VizPublicationService,
    private dialog: MatDialog
  ) {
    this.createProject = this.formBuilder.group({
      name: "",
    });
  }

  ngOnInit() {
    this.searchRequest = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.S_REQ));
    this.docCount = localStorage.getItem(LOCAL_STORAGE_KEYS.DOC_COUNT);
    this.isLoading = false;
    this.selectedVizText = this.getSelectedVizualizations();

    if (this.searchRequest.search.query) {
      this.query =
        this.searchRequest.search.query.length > 300
          ? this.searchRequest.search.query.substring(0, 300) + "..."
          : this.searchRequest.search.query;
    } else {
      this.query = "";
    }
    this.isQuery = this.query !== "" && this.query.length > 0;
  }

  ngAfterViewInit(): void {
    this.setFocus();
  }

  ngDestroy() {
    if (this.creationSubscription) {
      this.creationSubscription.unsubscribe();
    }
    if (this.pubResponseSubcription) {
      this.pubResponseSubcription.unsubscribe();
    }
  }

  getContentList(contentType: string): string {
    if (contentType == "db") {
      const dbFilterLocalItem = localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS);
      if (dbFilterLocalItem != undefined) {
        const dbFilters: DbFilter[] = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS))
          ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS))
          : [];
        //dbFacets.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())); //Sort in alphabetical order.

        if (dbFilters.length > 20) {
          dbFilters.length = 20;
          return (
            dbFilters
              .sort()
              .map((item) => item.name)
              .join(", ") + "..."
          );
        }
        return dbFilters
          .sort()
          .map((item) => item.name)
          .join(", ");
      }
    } else if (contentType == "pub") {
      const pubFilterLocalItem = localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS);
      if (pubFilterLocalItem != undefined) {
        const pubFilters: PubFilter[] = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS))
          ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS))
          : [];
        if (pubFilters.length > 20) {
          pubFilters.length = 20;
          return (
            pubFilters
              .sort()
              .map((item) => item.title)
              .join(", ") + "..."
          );
        }
        return pubFilters
          .sort()
          .map((item) => item.title)
          .join(", ");
      }
    }
    return "";
  }

  isPubFiltersExists(): boolean {
    const item = localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS);
    if (item === null) {
      return false;
    } else {
      return JSON.parse(item).length > 0;
    }
    //return false
  }

  isDbFiltersExists(): boolean {
    const item = localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS);

    if (item !== null) {
      return JSON.parse(item).length > 0;
    }
    return false;
  }

  toggleQuery() {
    this.isShowQuery = !this.isShowQuery;
  }

  onCreate(projectData) {
    // this.dialog.open(ProjectCreateSuccessModal, {
    //   disableClose: true,
    // });
    if (!projectData.name) {
      this.isError = true;
      this.errorMessage = this.NONAME;
    } else {
      this.isCreating = true;

      this.creationSubscription = this.pubService.createProject(this.getProject(projectData.name)).subscribe(
        (response) => {
          localStorage.setItem(LOCAL_STORAGE_KEYS.VIZ_CREATED, projectData.name);
          this.dialog.open(ProjectCreateSuccessModal, {
            disableClose: true,
          });
          this.isCreating = false;
        },
        (error: HttpErrorResponse) => {
          console.log("Error: ", error);
          this.isCreating = false;
        }
      );
    }
  }

  private getProject(projectname: string): VizPreProject {
    const search = this.addToDisplayPropertiesToFilters(this.searchRequest.search);

    const project: VizPreProject = {
      name: projectname,
      search: search,
      methods: this.selectedMethods(),
    };

    return project;
  }

  private selectedMethods(): Methods {
    let method: Method = { methodType: "" };
    const methods: Method[] = [];
    const allSelectedMethods: Methods = { method: methods };
    const vizSelection: {
      geoCardSelection: boolean;
      tmCardSelection: boolean;
      saCardSelection: boolean;
    } = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIZ_CARD_SELECTION));
    if (vizSelection.geoCardSelection === true) {
      method.methodType = "geography";
      methods.push(method);
    }
    if (vizSelection.tmCardSelection === true) {
      method = { methodType: "" };
      method.methodType = "topic";
      methods.push(method);
    }
    if (vizSelection.saCardSelection === true) {
      method = { methodType: "" };
      method.methodType = "sentiment";
      methods.push(method);
    }
    allSelectedMethods.method = methods;
    console.log("allselected Methods ------> " + JSON.stringify(allSelectedMethods));
    return allSelectedMethods;
  }

  addPubsToSearch() {
    const pubList = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS));
    const entryList = [];
    pubList.forEach((pub) => {
      entryList.push({
        searchValue: pub.id,
      });
    });
    const pf = {
      name: "pubTitle",
      entries: pubList,
    };
    this.searchRequest.search.filters.push(pf);
  }

  getSelectedVizualizations() {
    let rtnText = "";
    const cardObj = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIZ_CARD_SELECTION));
    //let obj = {'geoCardSelection': this.geoCardCheck, 'tmCardSelection': this.tmCardCheck};
    if (cardObj.geoCardSelection === true) {
      rtnText = "Geographic Analysis";
    }
    if (rtnText.length > 0 && cardObj.tmCardSelection === true) {
      rtnText = rtnText + ", " + "Topic Modeling";
    } else if (cardObj.tmCardSelection === true) {
      rtnText = "Topic Modeling";
    }
    if (rtnText.length > 0 && cardObj.saCardSelection === true) {
      rtnText = rtnText + ", " + "Sentiment Analysis";
    } else if (cardObj.saCardSelection === true) {
      rtnText = "Sentiment Analysis";
    }

    return rtnText;
  }

  private addToDisplayPropertiesToFilters(currentSearch: Search): Search {
    const pubDbDisplayFilters: Filter[] = this.populateToDisplayProps();
    const modifiedSearch = currentSearch;
    modifiedSearch.filters.push(...pubDbDisplayFilters);
    return modifiedSearch;
  }

  private populateToDisplayProps(): Filter[] {
    console.log("populating toDisplay properties");
    const top10Db_pubFacets: Filter[] = [];
    const pubFilters = localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS);
    const dbFacets = localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS);

    if (pubFilters != undefined && pubFilters != null) {
      from(JSON.parse(pubFilters) === null ? [] : JSON.parse(pubFilters))
        .pipe(
          take(10),
          map((pubEntry: any) => ({ searchValue: pubEntry.title })),
          toArray()
        )
        .subscribe((res) => {
          if (res && res.length > 0) {
            const pubToDisplay = {
              name: "pubTitlesToDisplay",
              entries: res,
            };
            top10Db_pubFacets.push(pubToDisplay);
          }
        });
    }

    if (dbFacets != undefined && dbFacets != null) {
      from(JSON.parse(dbFacets) === null ? [] : JSON.parse(dbFacets))
        .pipe(
          take(10),
          map((dbEntry: any) => ({ searchValue: dbEntry.name })),
          toArray()
        )
        .subscribe((res) => {
          if (res && res.length > 0) {
            const dbsToDisplay = {
              name: "datasourcesToDisplay",
              entries: res,
            };
            top10Db_pubFacets.push(dbsToDisplay);
          }
        });
    }

    return top10Db_pubFacets;
  }

  private setFocus() {
    this.inputRef.nativeElement.focus();
  }
}

@Component({
    selector: "project-create-success-modal",
    templateUrl: "project-create-success-modal.html",
    styleUrls: ["./analysis-create-content.component.scss"],
    standalone: false
})
export class ProjectCreateSuccessModal {
  @ViewChild("modal_x", { static: true }) firstTabIndex: any;
  @ViewChild("modal_button", { static: false }) lastTabIndex: any;

  constructor(public dialogRef: MatDialogRef<ProjectCreateSuccessModal>, private router: Router) {}

  onSuccess() {
    this.router.navigateByUrl("/analysis/dashboard");
    this.clearStorage();
    this.dialogRef.close();
  }

  private clearStorage() {
    const clearKeys: string[] = [
      LOCAL_STORAGE_KEYS.V_DOC_COUNT,
      LOCAL_STORAGE_KEYS.VS_REQ,
      LOCAL_STORAGE_KEYS.V_PUB_LIST,
      LOCAL_STORAGE_KEYS.SEARCH_TERM,
      LOCAL_STORAGE_KEYS.V_PUB_FILTERS,
      LOCAL_STORAGE_KEYS.PUB_FACETS,
    ];
    clearKeys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  loopTabindex(index: string, event: KeyboardEvent) {
    if (index === "lastTabIndex") {
      event.preventDefault();
      this.firstTabIndex.nativeElement.focus();
    } else if (event.shiftKey && event.key == "Tab") {
      event.preventDefault();
      this.lastTabIndex.nativeElement.focus();
    }
  }
}
